import React, { useState } from 'react';
import './HomePage.css';
import { useTranslation } from 'react-i18next';

// Flags mapping
const flagEmojis = {
  en: '🇬🇧',
  es: '🇪🇸',
  pt: '🇧🇷'
};

function HomePage({
  onPlay,
  onLogin,
  onLogout, 
  isLoggedIn, 
  userIsAnon, 
  userName, 
  userLang, 
  onLanguageChange,
  onNavigate 
}) {
  const { t } = useTranslation();
  const [isLangOpen, setIsLangOpen] = useState(false);
  const basePath = `/${userLang}`;

  const toggleLang = (e) => {
    e.stopPropagation();
    setIsLangOpen(!isLangOpen);
  };

  const selectLang = (lang) => {
    onLanguageChange(lang);
    setIsLangOpen(false);
  };

  return (
    <div className="home-container">
      {/* --- Top Bar (Language & User) --- */}
      <div className="home-top-bar">
        <div className="lang-wrapper">
          <button className="home-icon-button" onClick={toggleLang}>
            {flagEmojis[userLang]}
          </button>
          {isLangOpen && (
            <div className="home-lang-dropdown">
              {Object.keys(flagEmojis).map(lang => (
                <div key={lang} className="lang-item" onClick={() => selectLang(lang)}>
                  {flagEmojis[lang]} {lang.toUpperCase()}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* --- Main Content --- */}
      <div className="home-content">
        <div className="game-logo">
          <div className="logo-number">5</div>
          <div className="logo-text">
            <span>TOP</span>
            <span>GAME</span>
          </div>
        </div>

        <div className="home-cta-card">
          <h2>{t('home_intro_p1')}</h2>
          <p>{t('home_intro_p2')}</p>

          <div className="home-cta-actions">
            {/* Botão Jogar Principal */}
            <a
              className="btn-primary-play"
              href={`${basePath}/game`}
              onClick={(e) => {
                e.preventDefault();
                onPlay();
              }}
            >
              <span className="btn-icon">▶</span>
              {t('play_button')}
            </a>
          </div>
        </div>

        <div className="home-actions">
          {/* Botão Google Login */}
          {!isLoggedIn || userIsAnon ? (
            <div className="login-wrapper">
              <button className="btn-google" onClick={onLogin}>
                <span className="btn-icon">G</span>
                {t('login_google')}
              </button>
              <div className="save-badge">
                <span className="badge-icon">☁️</span> {t('login_badge_text')}
              </div>
            </div>
          ) : (
            <div className="user-welcome">
              <p>{t('welcome', { name: userName || '' })}</p>
              <button className="btn-logout" onClick={onLogout}>{t('logout')}</button>
            </div>
          )}
        </div>
      </div>

      {/* --- Footer Links --- */}
      {/* Only the links a player might strictly need from the home screen.
          Everything else (about, how-to-play, FAQ, guides, categories,
          updates) still lives in the in-game menu - see Menu.js. */}
      <div className="home-footer">
        <a
          href={`${basePath}/privacy`}
          onClick={(e) => {
            e.preventDefault();
            onNavigate('privacy');
          }}
        >
          {t('privacy_policy')}
        </a>
        <span className="separator">•</span>
        <a
          href={`${basePath}/terms`}
          onClick={(e) => {
            e.preventDefault();
            onNavigate('terms');
          }}
        >
          {t('terms_of_service')}
        </a>
        <span className="separator">•</span>
        <a
          href={`${basePath}/contact`}
          onClick={(e) => {
            e.preventDefault();
            onNavigate('contact');
          }}
        >
          {t('contact_us')}
        </a>
      </div>
    </div>
  );
}

export default HomePage;
